export default {
    agreement_print: "Келісімді басып шығару",
    agreement_template: "Келісімнің үлгісі",
    agreements: "Келісімдер",
    are_you_sure_you_want_to_delete_template: "Үлгіні жойғыңыз келе ме?",
    bite_templates: "Тістем",
    choose_fields_for_autocomplete: "Автотолтыру үшін қажетті мәндерді таңдаңыз:",
    complaints_templates: "Шағымдар",
    consents: "Келісімдер",
    contract_template: "Шарттың үлгісі",
    contracts: "Шарттар",
    development: "Даму",
    development_templates: "Даму",
    diseases: "Аурулар",
    diseases_templates: "Аурулар",
    document_template_word_file_note: "Word файлын үлгі ретінде тіркеуге болады. word файлында тегтерді $ белгісімен және фигуралық жақшалармен белгілеп, тек бас әріптерді ғана пайдалану керек. Мысалы: ${FIO_CLIENT}.",
    epikriz_templates: "Эпикриз",
    found_templates_with_diagnosis: "Диагноздары бар үлгілер табылды",
    full_treatment_template: "Емдеу үлігсі",
    general_template: "Үлгі",
    generate: "Қалыптастыру",
    generated: "Қалыптастырылды",
    inspection_templates: "Тексеру",
    medication_templates: "Емдеу",
    not_generated: "Қалыптастырылмады",
    objectively_templates: "Объективті",
    plan_treatment_template: "Емдеу жоспарының үлгісі",
    plansurvey: "Тексеру жоспары",
    plansurvey_templates: "Тексеру жоспары",
    recommendations_templates: "Ұсыныстар",
    refresh_status_in: "{vendor} күйін жаңарту",
    research: "Зерттеу деректері",
    research_templates: "Зерттеу деректері",
    researches: "Зерттеу",
    see_in_onlinecontract: "OnlineContract қарау",
    see_in_trustme: "TrustMe қарау",
    see_in_vendor: "{vendor} қарау",
    sign_via_onlinecontract: "OnlineContract арқылы қол қою",
    sign_via_trustme: "TrustMe арқылы қол қою",
    sign_via_vendor: "{vendor} арқылы қол қою",
    signed: "Қол қойылды",
    signed_via_onlinecontract: "OnlineContract арқылы қол қойылды",
    signed_via_trustme: "TrustMe арқылы қол қойылды",
    standard_diagnoses: "Стандартты диагноздар",
    subjectively_templates: "Субъективті",
    teeth_medication: "Емдеу",
    teeth_plansurvey: "Тексеру жоспары",
    teeth_recommendations: "Ұсыныстар",
    templates_treatments_categories: "Емдеу үлгілерінің санаттары",
    upload_signed: "Қол қойылғандарды жүктеу",
    uploaded: "Жүктелді"
}
